// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-titles-list[data-v-37aa25b1]{position:relative}.user-titles-list[data-v-37aa25b1] .title-list-card{max-width:100%}.user-titles-list-spinner[data-v-37aa25b1]{width:100%;height:40vh;display:flex;align-items:center;justify-content:center}.user-titles-list-content[data-v-37aa25b1]{max-width:1752px;margin:0 auto 20px}@media(max-width:1050px){.user-titles-list-content[data-v-37aa25b1]{margin:0 0 20px}}", ""]);
// Exports
module.exports = exports;
